import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import { LinkedinLogo, XLogo, TelegramLogo } from '@phosphor-icons/react';
import { PUBLIC_ROUTES } from '../constants/routes';
import { getDocsSiteUrl, getHelpSiteUrl, getApiDocsRoute, getHelpRoute, isOnMainSite } from '../utils/navigation';

function Footer() {
  const isMainSite = isOnMainSite();
  const isLocalhost = typeof window !== 'undefined' && 
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
  const docsUrl = getDocsSiteUrl() + getApiDocsRoute(PUBLIC_ROUTES.API_DOCS_OVERVIEW);
  const helpUrl = getHelpSiteUrl() + getHelpRoute(PUBLIC_ROUTES.HELP);

  return (
    <footer className="footer">
      <div className="footer-main">
        <div className="footer-col footer-brand">
          <div className="footer-logo-row">
            <img src="https://firebasestorage.googleapis.com/v0/b/wesplit-35186.firebasestorage.app/o/website%2Fwesplit-logo.png?alt=media&token=4f50d17a-de63-455e-bb13-9a6950784159" alt="WeSplit logo" className="footer-logo" />
          </div>
          <p className="footer-desc">
            Because spending together should always feel simple and social.
          </p>
          <div className="footer-socials">
            <a href="https://x.com/wesplit_io" className="footer-social" target='_blank' rel="noreferrer">
              <XLogo weight="regular" size={22} />
            </a>
            <a href="https://t.me/+v-e8orBns-llNThk" className="footer-social" target='_blank' rel="noreferrer">
              <TelegramLogo weight="regular" size={22} />
            </a>
            <a href="https://www.linkedin.com/company/wesplit-io/" className="footer-social" target='_blank' rel="noreferrer">
              <LinkedinLogo weight="regular" size={22} />
            </a>
          </div>
        </div>
        <div className="footer-right">
          <div className="footer-col footer-links">
            <div className="footer-col-title">Explore</div>
            <a href="#splitmethods">Split Modes</a>
            <a href="#solution">Shared Wallets</a>
            <a href="#social">Social Layer</a>
            <a href="#earn">Earn</a>
            <a href="#faq">FAQs</a>
          </div>
          <div className="footer-col footer-pages">
            <div className="footer-col-title">Resources</div>
            {isLocalhost ? (
              <>
                <Link to={PUBLIC_ROUTES.HELP}>Help Center</Link>
                <Link to={PUBLIC_ROUTES.API_DOCS_OVERVIEW}>API Documentation</Link>
              </>
            ) : isMainSite ? (
              <>
                <a href={helpUrl}>Help Center</a>
                <a href={docsUrl}>API Documentation</a>
              </>
            ) : (
              <>
                <Link to={getHelpRoute(PUBLIC_ROUTES.HELP)}>Help Center</Link>
                <Link to={getApiDocsRoute(PUBLIC_ROUTES.API_DOCS_OVERVIEW)}>API Documentation</Link>
              </>
            )}
            <a href="https://wesplit.notion.site/WeSplit-Brand-Style-Guide-2e66aba8997c80648f5ef784b555bb51?source=copy_link" target="_blank" rel="noopener noreferrer">Press Kit</a>
          </div>
          <div className="footer-col footer-pages">
            <div className="footer-col-title">Legal</div>
            <Link to={PUBLIC_ROUTES.TERMS}>Terms</Link>
            <Link to={PUBLIC_ROUTES.PRIVACY}>Privacy Policy</Link>
            <Link to={PUBLIC_ROUTES.TERMS_OF_SERVICE}>Terms of Sale</Link>
          </div>
        </div>


      </div>
      <div className="footer-bottom">
        <hr className="footer-sep" />
        <div className="footer-copyright">
          Copyright ©2025 WeSplit. All rights reserved
        </div>
      </div>
    </footer>
  );
}

export default Footer;
